import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PhoneNumberField from 'components/form/PhoneNumberField'
import BrandedButton from 'components/BrandedButton'
import ChoiceField from 'components/form/ChoiceField'
import GenericNameField from 'components/form/GenericNameField'
import { validateOwnerForm } from 'utilities/formValidator.util'
import withInputAnalytics from 'hoc/WithInputAnalytics'

import {
  clearFieldError, setFieldErrors, setFieldValues,
  submitForm,
} from './actions'
import { OWNS_SERVICE_KEY, LANDLINE_KEY, GA_EVENT_CATEGORY, AVC_ID_KEY, KNOWS_AVC_ID_KEY } from './constants'
import styles from './styles.scss'

const TrackedPhoneNumberField = withInputAnalytics(GA_EVENT_CATEGORY)(PhoneNumberField)
const AvcIdField = withInputAnalytics(GA_EVENT_CATEGORY)(GenericNameField)

class OwnerCheckStage extends PureComponent {
  static propTypes = {
    // From redux
    // result: PropTypes.string,
    isLoading: PropTypes.bool,
    askLandline: PropTypes.bool,
    fieldError: PropTypes.object,

    // From Wagtail
    title: PropTypes.string,
    preText: PropTypes.string,
    phoneNumberText: PropTypes.string,
    ownerLabel: PropTypes.string,
    ownerNotLabel: PropTypes.string,
    landlineFieldName: PropTypes.string,
    notOwnerText: PropTypes.string,
    avcIdSubtitle: PropTypes.string,
    avcIdDescription: PropTypes.string,
    knowsAvcIdLabel: PropTypes.string,
    doesNotKnowAvcIdLabel: PropTypes.string,
    avcIdInputDescription: PropTypes.string,
    ownerAvcFootnote: PropTypes.string,

    // Redux functions
    submitForm: PropTypes.func,
    clearFieldError: PropTypes.func,
    setFieldErrors: PropTypes.func,
  }

  static defaultProps = {
    isLoading: false,
    askLandline: false,
    fieldError: {},
    title: 'Installation',
    preText: '<p>As part of the installation of your nbn service the current internet and/or ' +
    'landline phone service at this address will be disconnected.</p>',
    phoneNumberText: '<p>This will help us process your order quicker. To check the number, ' +
    'call your mobile phone from the landline phone or view a recent phone bill.</p>',
    notOwnerText: '<p>That\'s fine, you can still place your order for a new nbn service.</p>',
    ownerLabel: 'Yes. I am the owner of this service',
    ownerNotLabel: 'No, I am not the owner of this service',
    landlineFieldName: 'Landline Phone Number (Optional)',
    avcIdSubtitle: 'I want to transfer to Kogan Internet',
    avcIdDescription: "<p>To transfer your current nbn service to Kogan, you'll need to provide your AVC ID. " +
    'You can find it on a recent bill or by logging into your account with your current provider.</p>',
    knowsAvcIdLabel: 'I know my AVC ID',
    doesNotKnowAvcIdLabel: "I don't know my AVC ID",
    avcIdInputDescription: 'e.g. AVC123456789012',
    ownerAvcFootnote: '<p>If you can\'t find your AVC ID right now, that\'s okay - but you will need to provide' +
      ' your AVC ID later to finalise your order. We will call you to assist if needed.</p>',
    submitForm: f => f,
    clearFieldError: f => f,
    setFieldErrors: f => f,
  }

  constructor(props) {
    super(props)
    this.state = {
      phone: '',
      serviceOwner: null,
      knowsAvcId: null,
      avcId: '',
    }
  }

  onPhoneChange = (event) => {
    this.setState({ phone: event.target.value })
  }

  onServiceOwnerChange = (event) => {
    this.setState({ serviceOwner: event.target.value === 'true' })
    if (this.props.fieldError[OWNS_SERVICE_KEY]) {
      this.props.clearFieldError(OWNS_SERVICE_KEY)
    }
  }

  onKnowsAvcIdChange = (event) => {
    this.setState({ knowsAvcId: event.target.value === 'true' })
    if (this.props.fieldError[KNOWS_AVC_ID_KEY]) {
      this.props.clearFieldError(KNOWS_AVC_ID_KEY)
    }
  }

  onAvcIdChange = (event) => {
    this.setState({ avcId: event.target.value })
    if (this.props.fieldError[AVC_ID_KEY]) {
      this.props.clearFieldError(AVC_ID_KEY)
    }
  }

  onSubmit = () => {
    const data = {
      [OWNS_SERVICE_KEY]: this.state.serviceOwner,
      [AVC_ID_KEY]: this.state.avcId,
    }

    // Move validation checks here
    if (this.state.serviceOwner == null) {
      this.props.setFieldErrors({ [OWNS_SERVICE_KEY]: 'This is required' })
      return
    }
    if (this.state.serviceOwner === true && this.state.knowsAvcId == null) {
      this.props.setFieldErrors({ [KNOWS_AVC_ID_KEY]: 'This is required' })
      return
    }
    if (this.state.knowsAvcId === true && !this.state.avcId) {
      this.props.setFieldErrors({ [AVC_ID_KEY]: 'This is required' })
      return
    }

    const errors = validateOwnerForm(data)
    if (errors === true) {
      this.props.submitForm(data)
    } else {
      this.props.setFieldErrors(errors)
    }
  }

  onFocusPhone = () => {
    if (this.props.fieldError[LANDLINE_KEY]) {
      this.props.clearFieldError(LANDLINE_KEY)
    }
  }

  render() {
    const {
      title,
      preText,
      phoneNumberText,
      notOwnerText,
      ownerLabel,
      ownerNotLabel,
      landlineFieldName,
      isLoading,
      askLandline,
      fieldError,
      avcIdSubtitle,

    } = this.props

    const options = [
      { label: ownerLabel, value: 'true' },
      { label: ownerNotLabel, value: 'false' },
    ]

    return (
      <div className={styles.wrapper}>
        <h2>{title}</h2>
        <div
          className={styles.preText}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: preText }}
        />
        <ChoiceField
          name={OWNS_SERVICE_KEY}
          options={options}
          value={this.state.serviceOwner !== null && this.state.serviceOwner.toString()}
          onChange={this.onServiceOwnerChange}
          loading={isLoading}
          errorMessage={fieldError[OWNS_SERVICE_KEY]}
          required
        />
        {this.state.serviceOwner === true && askLandline &&
          <TrackedPhoneNumberField
            labelText={landlineFieldName}
            fieldName={LANDLINE_KEY}
            value={this.state.phone}
            isRequired={false}
            loading={isLoading}
            onChange={this.onPhoneChange}
            onFocus={this.onFocusPhone}
            errorMessage={fieldError[LANDLINE_KEY]}
          />
        }
        {this.state.serviceOwner === true && askLandline &&
          <div
            className={styles.postText}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: phoneNumberText }}
          />
        }
        {this.state.serviceOwner === true && (
          <React.Fragment>
            {avcIdSubtitle && <h3>{avcIdSubtitle}</h3>}
            <div
              className={styles.preText}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: this.props.avcIdDescription }}
            />
            <ChoiceField
              name={KNOWS_AVC_ID_KEY}
              options={[
                { label: this.props.knowsAvcIdLabel, value: 'true' },
                { label: this.props.doesNotKnowAvcIdLabel, value: 'false' },
              ]}
              value={this.state.knowsAvcId !== null && this.state.knowsAvcId.toString()}
              onChange={this.onKnowsAvcIdChange}
              loading={isLoading}
              errorMessage={fieldError[KNOWS_AVC_ID_KEY]}
              required
            />

            {this.state.knowsAvcId && (
              <AvcIdField
                labelText="AVC ID"
                fieldName={AVC_ID_KEY}
                value={this.state.avcId}
                isRequired
                loading={isLoading}
                onChange={this.onAvcIdChange}
                errorMessage={fieldError[AVC_ID_KEY]}
                maxLength={15}
                description={this.props.avcIdInputDescription}
              />)}
            {this.state.knowsAvcId === false && (
              <div
                className={styles.postText}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: this.props.ownerAvcFootnote }}
              />
            )}
          </React.Fragment>
        )}
        {this.state.serviceOwner === false &&
          <div
            className={styles.postText}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: notOwnerText }}
          />
        }
        <div className={styles.buttonWrapper}>
          <BrandedButton
            labelText="Continue"
            loading={isLoading}
            onClick={this.onSubmit}
            fitContent
          />
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    fieldValues: state.checkoutReducer.ownerFieldValues,
    fieldError: state.checkoutReducer.ownerFieldError,
    isLoading: state.checkoutReducer.isLoading,
    askLandline: state.checkoutReducer.ownerAskLandline,
  }
}

// Anything returned from this function will end up as props
function mapDispatchToProps(dispatch) {
  // Whenever dispatch is called the result should be passed
  // to all of the reducers
  return bindActionCreators(
    {
      setFieldErrors,
      clearFieldError,
      setFieldValues,
      submitForm,
    },
    dispatch
  )
}

// To promote a component to a container (smart component) - it needs
// to know about this new dispatch method. Make it available
// as a prop.
export default connect(mapStateToProps, mapDispatchToProps)(OwnerCheckStage)



// WEBPACK FOOTER //
// ./containers/stages/OwnerCheckStage/index.jsx